/**
 * All Gutenberg Pro Plugins will be included here
 */

import "./global-settings";

import domReady from "@wordpress/dom-ready";
import { render } from "@wordpress/element";
import App from "./zoom-out/index";

domReady(() => {
	let observer = new MutationObserver((_, observer) => {
		let toolbarElement = document.querySelector(".edit-post-header__toolbar");

		if (toolbarElement) {
			let wrapper = document.createElement("div");
			wrapper.id = "gp-zoom-out-toolbar-items";
			wrapper.style.display = "flex";

			toolbarElement.appendChild(wrapper);

			render(
				<div>
					<App />
				</div>,
				wrapper,
			);

			observer.disconnect();
		}
	});

	observer.observe(document.body, { childList: true, attributes: true });
});
